<template>
  <main class="common_base_info">
    <el-row>
      <el-col
        :span="item.span || 12"
        v-for="(item, index) in list"
        :key="index"
      >
        <span class="common_base_info_title">{{ item.label }}:</span>
        <span class="common_base_info_info">{{ item.val || '- -' }}</span>
        <span
          v-if="item.isUseBtn"
          @click="item.callback"
          class="btn-default-color"
          >{{ item.btnTxt }}</span
        >
      </el-col>
    </el-row>
  </main>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      },
    },
  },
  watch: {
    list(val) {
      this.list = val
    },
  },
}
</script>

<style lang="stylus">
@import '../../assets/css/common-color.styl'
.common_base_info
  padding-left 12px
  .el-col
    margin-bottom 24px
  &_title
    color gray03
  &_info
    color gray01
    word-break break-all
  .btn-default-color
    margin-left 5px
    color #5878b4
    cursor pointer
  .common_base_info_title
    color gray02
</style>
